import {
  ballotDataCollectionPolicy,
  ballotDataCollectionPolicyModalHeading,
} from 'app/components/Ballot/constants'
import { Box, Modal } from 'app/components/design-system-components'

interface CollectionPolicyModalProps {
  toggleCollectionPolicyModal: () => void
  teamSlug: string
}

export const modalBodyVarcVic = (
  <Box>
    <Box mt={4}>
      You will be asked some demographic questions. This information will be
      used for research purposes only.
    </Box>

    <Box mt={4}>
      Data collected from applications to these homes will be used to evaluate
      and improve the Affordable Housing Rental Scheme.
    </Box>

    <Box mt={4}>
      Data will be securely stored (electronically) for seven years. After seven
      years unit record data will be securely destroyed in accordance with the
      Public Records Act 1973 (Vic) and the Privacy and Data Protection Act 2014
      (Vic) Victorian Protective Data Security Framework. The Department of
      Families, Fairness and Housing Records Management Unit and Cyber Security
      Unit will supervise the data destruction.
    </Box>

    <Box mt={4}>
      Homes Victoria will not disclose any information for a purpose other than
      evaluating the Affordable Housing Rental Scheme, unless your express prior
      consent is sought or are required to do so by an Australian law.
    </Box>

    <Box mt={4}>
      Any information published from program evaluation will be de-identified.
    </Box>
  </Box>
)

export const modalBodyQldAffordable = (
  <Box>
    <Box mt={4}></Box>
    You will be asked some demographic questions. This information will be used
    for research purposes only.
    <Box mt={4}>
      Data collected from applications for these dwellings will be used to
      evaluate and improve the HIF Affordable Housing Program.
    </Box>
    <Box mt={4}>
      Data will be securely stored (electronically) for seven years. After seven
      years unit record data will be securely destroyed in accordance with the
      Information Privacy Act 2009 (Qld) and the Privacy Act 1988 (Cth).
    </Box>
    <Box mt={4}>
      National Affordable Housing will not disclose any information for a
      purpose other than evaluating the HIF Affordable Housing Program, unless
      your express prior consent is sought or are required to do so by an
      Australian law.
    </Box>
    <Box mt={4}>
      Any information published from program evaluation will be de-identified.
    </Box>
  </Box>
)

function CollectionPolicyModal({
  toggleCollectionPolicyModal,
  teamSlug = '',
}: CollectionPolicyModalProps) {
  const modalBody = ballotDataCollectionPolicy(teamSlug)
  const modalHeading = ballotDataCollectionPolicyModalHeading(teamSlug)

  return (
    <Modal
      modalHeading={modalHeading}
      modalBody={modalBody}
      showPrimaryButton={false}
      toggleModal={toggleCollectionPolicyModal}
      secondaryAction={toggleCollectionPolicyModal}
      secondaryLabel="Close"
      modalFooter={undefined}
      primaryLabel={undefined}
      primaryAction={undefined}
    />
  )
}

export default CollectionPolicyModal
